import {
  clickReceiverAttribute,
  generateLoadAttribute,
  rootContainerAttribute,
} from 'utils/lazyLoadEmbeds';

import styles from './youtube.css';

const youtubeEmbedRegex = /https:\/\/(?:www\.)?youtube\.com\/embed\/([^?]+)/;

export const isYoutubeEmbedLink = (url) => Boolean(url.match(youtubeEmbedRegex));

export const extractYoutubeVideoID = (url) => url.match(youtubeEmbedRegex)[1];

export const generateThumbnailImage = (videoId) => `https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`;

const playButton = (videoId) => `
<button class="${styles.playButton}" ${generateLoadAttribute(videoId)}>
  <span="${styles.visuallyHidden}">Play</span>
</button>
`;

const thumbnailContainer = (videoId) => `
<img alt="video thumbnail" class="${styles.thumbnail}" src="${generateThumbnailImage(videoId)}" />
`;

const createLazyLoadFacade = (videoId) => `
<div class="${styles.lazyLoadEmbed}" ${rootContainerAttribute}>
  <div class="${styles.hoverOverlay}" ${clickReceiverAttribute}>
    ${thumbnailContainer(videoId)}
    ${playButton(videoId)}
  </div>
</div>
`;

const autoplayQueryParam = 'autoplay';
const autoplayQueryParamActive = `${autoplayQueryParam}=1`;

export const addAutoplayToUrl = (url) => {
  if (url.includes(autoplayQueryParamActive)) {
    return url;
  }
  if (url.includes(autoplayQueryParam)) {
    return url.replace(new RegExp(`${autoplayQueryParam}=[^&]`), autoplayQueryParamActive);
  }
  if (url.includes('?')) {
    return `${url}&${autoplayQueryParamActive}`;
  }
  return `${url}?${autoplayQueryParamActive}`;
};

export const addIframeAllowAutoplay = (originalAllow = '') => {
  if (originalAllow.includes('autoplay')) {
    return originalAllow;
  }
  return [originalAllow, 'autoplay']
    .filter((allow) => 0 < allow.length)
    .join('; ');
};

export const generateLazyLoadEmbed = (embed) => {
  const { allow, src } = embed.attribs;
  const videoId = extractYoutubeVideoID(src);
  const lazyLoadFacade = createLazyLoadFacade(videoId);
  return {
    videoId,
    lazyLoadFacade,
    iframe: {
      ...embed,
      attribs: {
        ...embed.attribs,
        src: addAutoplayToUrl(src),
        allow: addIframeAllowAutoplay(allow),
      },
    },
  };
};
